import type { LegalSection } from "@serophin/shared";
import { CONTACT_US } from "./app";

export const TERMS_LIABILITY: LegalSection[] = [
  {
    heading: "Indemnification",
    blocks: [
      "You agree to indemnify, defend, and hold harmless Serophin, its affiliates, officers, directors, employees, agents, and licensors from and against any claims, liabilities, damages, losses, costs, expenses, or fees (including reasonable attorneys' fees) arising from:",
      { list: ["Your use of the Service", "Your violation of these Terms", "Your violation of any rights of another party", "Your User Content"] },
    ],
  },
  {
    heading: "Disclaimer of Warranties",
    blocks: [
      'The service is provided "as is" and "as available" without warranties of any kind, either express or implied.',
      "We do not warrant that the Service will be uninterrupted, secure, or error-free, or that any defects will be corrected. The content provided through the Service is for informational purposes only and should not be relied upon as professional, medical, legal, or financial advice.",
    ],
  },
  {
    heading: "Limitation of Liability",
    blocks: [
      "To the maximum extent permitted by law, Serophin shall not be liable for any indirect, incidental, special, consequential, or punitive damages, or any loss of profits or revenues.",
      "Our total liability to you for any damages shall not exceed the amount you have paid us in the twelve (12) months prior to the claim.",
      "Nothing in these Terms limits liability that cannot be limited by law, including for death or personal injury caused by our negligence, or your rights under the Australian Consumer Law or any other consumer law that applies to you.",
    ],
  },
  {
    heading: "DMCA and Copyright Policy",
    blocks: [
      `We respect intellectual property rights and comply with the Digital Millennium Copyright Act (DMCA). If you believe your copyrighted work has been infringed, please ${CONTACT_US}.`,
      "Your notice must include: identification of the copyrighted work, identification of the infringing material, your contact information, a statement of good faith belief, and a statement of accuracy under penalty of perjury.",
      "We maintain a policy of terminating repeat infringers in appropriate circumstances.",
    ],
  },
  {
    heading: "Advertising",
    blocks: [
      "!tldr does not display advertising. If we introduce it in the future, we will update these Terms and our Privacy Policy first, and will display respectful advertising that does not intentionally serve clickbait or misleading content.",
    ],
  },
  {
    heading: "Service Modifications",
    blocks: [
      "We reserve the right to modify, suspend, or discontinue the Service or any features at any time without notice. We shall not be liable to you or any third party for any modification, suspension, or discontinuance of the Service.",
      'We may offer beta features or test new functionality. Such features are provided "as is" without warranties and may be discontinued at any time.',
    ],
  },
  {
    heading: "Termination",
    blocks: [
      "We reserve the right to suspend or terminate your account and access to the Service at our sole discretion, without notice, for conduct that we believe violates these Terms or is harmful to other users, us, or third parties, or for any other reason.",
      "Upon termination, your right to use the Service will immediately cease. All provisions of these Terms that by their nature should survive termination shall survive.",
    ],
  },
];
